import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Rnd } from 'react-rnd';
import FakeBrowser from './FakeBrowser';

var FakeBrowserWithWrapper = function FakeBrowserWithWrapper(_ref) {
  var children = _ref.children,
      rndProps = _ref.rndProps;
  return /*#__PURE__*/React.createElement(Rnd, _extends({
    disableDragging: true
  }, rndProps, {
    default: _objectSpread({
      x: 0,
      y: 0,
      width: '98%',
      height: 'auto'
    }, rndProps && rndProps.default),
    enableResizing: _objectSpread({
      top: false,
      topRight: false,
      right: true,
      bottomRight: true,
      bottom: true,
      bottomLeft: false,
      left: false,
      topLeft: false
    }, rndProps && rndProps.enableResizing),
    style: _objectSpread({
      backgroundColor: 'rgb(250, 250, 250)',
      border: 'solid 1px #ddd',
      padding: '20px',
      position: 'relative'
    }, rndProps && rndProps.style)
  }), /*#__PURE__*/React.createElement(FakeBrowser, null, children));
};

export default FakeBrowserWithWrapper;